
import React, { memo } from 'react';
import { SchedulerDimensions, Track } from './schedulerTypes';

interface CrosshairIndicatorProps {
  hoveredCell: {
    trackId: string | null;
    dayIndex: number | null;
  };
  dimensions: SchedulerDimensions;
  tracksMap: Map<string, Track[]>;
}

export const CrosshairIndicator = memo(({
  hoveredCell,
  dimensions,
  tracksMap,
}: CrosshairIndicatorProps) => {
  // If no cell is hovered, don't render anything
  if (hoveredCell.trackId === null || hoveredCell.dayIndex === null) {
    return null;
  }

  // Find the track and calculate its position
  let trackIndex = -1;
  let categoryIndex = -1;
  let track: Track | undefined;

  Array.from(tracksMap.entries()).forEach(([category, tracks], catIdx) => {
    const foundTrackIndex = tracks.findIndex(t => t.id === hoveredCell.trackId);
    if (foundTrackIndex !== -1) {
      trackIndex = foundTrackIndex;
      categoryIndex = catIdx;
      track = tracks[foundTrackIndex];
    }
  });

  if (!track) return null;

  const CATEGORY_HEADER_HEIGHT = 30;
  const trackY = trackIndex * dimensions.trackHeight + categoryIndex * CATEGORY_HEADER_HEIGHT + CATEGORY_HEADER_HEIGHT;
  
  // Calculate the position for the vertical crosshair line
  const dayX = (hoveredCell.dayIndex * dimensions.dayWidth);

  return (
    <>
      {/* Vertical line going down from the header to all tracks */}
      {/*
      <div 
        style={{
          position: 'absolute',
          top: dimensions.timeHeaderHeight,
          left: dimensions.trackHeaderWidth + dayX + dimensions.dayWidth / 2,
          width: '1px',
          height: dimensions.totalHeight,
          backgroundColor: 'rgba(59, 130, 246, 0.5)', // Use a blue color with opacity
          pointerEvents: 'none', // Make sure the line doesn't interfere with interactions
          zIndex: 1,
        }}
      />
      */}
    </>
  );
});
